import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrButton, {
  SR_BUTTON_FONT_SIZE_MICRO,
  SR_BUTTON_HEIGHT_SHORTER,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';

import './SrUtilityProfitPartnerUsersDataTableHeader.less';

const SrUtilityProfitPartnerUsersDataTableHeader = ({
  searchInput,
  onAddMemberClick,
  onSearchInputChange,
  canAddOrEditTeamMembers,
}) => {
  return (
    <SrBox styleName="SrUtilityProfitPartnerUsersDataTableHeader">
      <SrText font="greycliff" weight="700" fontSize="28px">
        Team Members
      </SrText>
      <SrBox height="32px" marginLeft="auto" display="flex" flexDirection="row" overflow="hidden">
        {canAddOrEditTeamMembers && (
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_GREEN}
            fontSizeType={SR_BUTTON_FONT_SIZE_MICRO}
            heightType={SR_BUTTON_HEIGHT_SHORTER}
            width="146px"
            onClick={onAddMemberClick}
          >
            + Add Member
          </SrButton>
        )}
        <SrBox height="28px" minWidth="190px" marginLeft="10px">
          <input
            value={searchInput}
            type="text"
            onChange={onSearchInputChange}
            placeholder="Search name, phone or email"
            styleName="searchInput"
          />
        </SrBox>
      </SrBox>
    </SrBox>
  );
};

SrUtilityProfitPartnerUsersDataTableHeader.displayName =
  'SrUtilityProfitPartnerUsersDataTableHeader';

SrUtilityProfitPartnerUsersDataTableHeader.propTypes = {
  onSearchInputChange: PropTypes.func.isRequired,
  onAddMemberClick: PropTypes.func.isRequired,
  searchInput: PropTypes.string.isRequired,
};

export default SrUtilityProfitPartnerUsersDataTableHeader;
